import { Suspense } from "react";
import { usePrefetchPortfolioAnalytics } from "api/overview/usePrefetchPortfolioAnalytics";
import { LoadingIndicator } from "components";
import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";
import { Outlet } from "react-router-dom";
export const MainLayout = () => {
  // Warm the slow per-portfolio analytics cache for every portfolio on login,
  // before the user reaches the "Avkastning"/holdings pages.
  usePrefetchPortfolioAnalytics();

  return (
    <div className="box-border text-gray-900 bg-gray-50 h-[calc(100vh-0.5rem)]">
      <ErrorBoundary>
        <Suspense fallback={<LoadingIndicator center />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
};
